import axios from 'axios';
import type { TeamInfo } from '../../Router/pages/ManageUsersPage/Hooks';

const update = async (
  teamId: string,
  updates: TeamInfo & { usersToAdd?: string[]; usersToRemove?: string[] },
) => axios.post(`/team/${teamId}/update`, updates);

export default update;
